// extracted by css-extract-rspack-plugin
export default {"frosted":"_5c64abd3","solid":"_979fb793","small":"_1244ec71","medium":"_2052d873","large":"_49179093"};